import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { RolesApi } from 'data/roles';
import { updateMemberAction, InviteOrUpdateMembersPayload } from '../actions';
import { MembersAPI } from '../api';
import { updateMember } from '../slice';

function* updateMembers(payload, handleSuccess) {
  const users = yield MembersAPI.updateMember(payload);

  yield put(updateMember(users));

  if (handleSuccess) {
    handleSuccess();
  }
}
function* updateMembersSaga(
  action: PayloadAction<InviteOrUpdateMembersPayload>,
) {
  const {
    payload: {
      data,
      role,
      handleAlways = () => {},
      handleSuccess,
      handleFailure = () => {},
    },
  } = action;

  try {
    let payload = data[0];

    if (role.isNew) {
      try {
        const createdRole = yield RolesApi.createWithDefaultPlaceholder({
          roleName: role.value,
        });

        payload = {
          ...payload,
          user: {
            ...payload.user,
            role: createdRole,
            defaultCapacity: payload.user.defaultCapacity,
            capacityMinutes: payload.user.capacityMinutes,
          },
        };

        yield updateMembers(payload, handleSuccess);
      } catch (error) {
        message.error('Creating a new role failed');

        handleFailure();
      }
    } else {
      yield updateMembers(payload, handleSuccess);
    }
  } catch (error) {
    handleFailure();
  }

  handleAlways();
}

export const watchUpdateMembersSaga = function* (): Generator {
  yield takeLatest(updateMemberAction.type, updateMembersSaga);
};
